// permiso.guard.ts
import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { map, Observable, of, tap } from 'rxjs';
import { SessionService } from '@core/services/session.service';

export const permisoCanMatch: CanMatchFn = (route): Observable<boolean | UrlTree> => {
    const sessionService = inject(SessionService);
    const router = inject(Router);
    const accion = route.data?.['accion'] as string;

    if (!accion) {
        return of(false);
    }
    return sessionService.tieneAcceso(accion).pipe(
        tap(),
        map(ok => ok || router.createUrlTree(['']))
    );
};
